<template>
  <div class="dialog--message__wrapper" v-if="visible">
    <div class="dialog"
         :style="{'width':width}"
         :class="[type ? 'dialog--'+ type : '' ]"
    >
      <div class="dialog-header">
        <h2 v-html="title"></h2>
        <span v-show="showClose" @click="close">X</span>
      </div>
      <div class="dialog-body">
        <slot></slot>
      </div>
      <div class="dialog-footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    componentName: 'Dialog',
    data() {
      return {
        visible: false
      }
    },
    props: {
      title: String,
      showClose: {
        type: Boolean,
        default: true
      },
      type:String,
      width: String,
      beforeClose: {
        type: Function,
        default: function() {}
      }
    },
    methods: {
      open() {
        this.visible = true;
      },
      close() {
        this.visible = false;
      }
    },
    mounted() {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dialog/Dialog.vue